import AuthorizeComponent from "./containers/AuthorizeContainer";

export { AuthorizeComponent };
export default AuthorizeComponent;
